import { Component, OnInit } from '@angular/core';
import { faBars } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-courses-style-two',
  templateUrl: './courses-style-two.component.html',
  styleUrls: ['./courses-style-two.component.scss']
})
export class CoursesStyleTwoComponent implements OnInit {
  
  faBars = faBars;
  constructor() { }

  ngOnInit(): void {
  }

}
